import { ReactNode } from 'react';
import styled, { InterpolationValue } from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';
import { FONT_STACK, FontSize, FontWeight } from '../../styles/constants';

interface Props {
  children: ReactNode;
  fontColor?: InterpolationValue;
  fontSize?: FontSize;
  fontWeight?: FontWeight;
}

const PushingP = styled.p<Props>`
  ${FONT_STACK}
  color: ${props => props.fontColor};
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.fontWeight};
`;

export const P = ({ children, ...restProps }: Props) => (
  <PushingP {...restProps}>{children}</PushingP>
);

P.defaultProps = {
  fontColor: ThemeColours.mono800,
  size: FontSize.REGULAR,
  weight: FontWeight.REGULAR,
};
